import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Grid2 } from '@mui/material';

import { TabsCostsEarningCard } from 'pages/Dashboard/components/CardsWithTabs';
import { Button, ButtonColor, FiatBalanceCard, HostedMinersCard, ModalTopUp } from 'shared';
import { EarningsCard } from 'shared/EarningsCard';
import { useTheme } from 'themes/themeProvider';
import { Currency } from 'types/general.types';
import { imageMap } from 'utils/imageMap';

interface CardsBlockProps {
  testId?: string;
}

export const CardsBlock: FC<CardsBlockProps> = ({ testId }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const [isPopupOpened, setIsPopupOpened] = useState(false);

  const navigateWalletHandler = () => navigate('/my-wallets', { state: { currency: Currency.BTC } });

  const onTopUpHandler = () => {
    setIsPopupOpened(!isPopupOpened);
  };
  return (
    <React.Fragment>
      <Grid2 container spacing={{ xs: 2, md: 1, lg: 2 }} mb={6} data-testid={testId}>
        <Grid2
          size={{ xs: 12, md: 6, lg: 3 }}
          sx={{
            height: '300px',
            borderRadius: '12px',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <HostedMinersCard />
        </Grid2>

        <Grid2
          size={{ xs: 12, md: 6, lg: 3 }}
          sx={{
            p: 2,
            background: `url(${imageMap.images[theme.widgets.dailyProfit.imageId]})`,
            color: theme.widgets.fiatWallet.textColor,
            height: '300px',
            borderRadius: '12px',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <FiatBalanceCard
            actionElement={
              <Button
                onClick={navigateWalletHandler}
                color={ButtonColor.SECONDARY}
                variant='contained'
                sx={{ alignSelf: 'center', marginTop: 'auto' }}
              >
                Go to wallets
              </Button>
            }
          />
        </Grid2>

        <Grid2
          size={{ xs: 12, md: 6, lg: 3 }}
          sx={{
            p: 2,
            background: `url(${imageMap.images[theme.widgets.bitcoinWallet.imageId]})`,
            color: theme.widgets.bitcoinWallet.textColor,
            borderRadius: '12px',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <TabsCostsEarningCard />
        </Grid2>

        <Grid2
          size={{ xs: 12, md: 6, lg: 3 }}
          sx={{
            p: 2,
            background: `url(${imageMap.images[theme.widgets.dailyPayout.imageId]})`,
            color: theme.widgets.dailyPayout.textColor,
            height: '300px',
            borderRadius: '12px',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* <TabsPaidEarnedInfo /> */}
          <EarningsCard />
        </Grid2>
      </Grid2>

      {isPopupOpened && <ModalTopUp isOpen={isPopupOpened} onClose={onTopUpHandler} />}
    </React.Fragment>
  );
};
